import { UpdateContractContactsBodyDto } from '@ekt-group/general-purpose-api-interfaces';
import { useMutation } from '@tanstack/react-query';

import { mutationFn } from '@/lib/react-query';

const updateContactFormFn = (contractId: number, data: UpdateContractContactsBodyDto) => {
  return mutationFn(`/contracts/${contractId}/contacts`, data, 'patch');
};

export const useUpdateContactForm = (contractId: number) =>
  useMutation({
    mutationFn: (data: UpdateContractContactsBodyDto) => updateContactFormFn(contractId, data),
  });
